import { useApolloClient } from '@apollo/client';
import { MeDocument, type MeQuery } from 'api/core/generated';
import {
  ABBREVIATIONS_BY_LANGUAGES_MAP,
  LANGUAGES_BY_ABBREVIATIONS_MAP,
} from 'app-constants';
import { useTranslation } from 'react-i18next';

import { useUpdateUserLanguage } from './use-update-user-language';

export const useCheckUpdateUserLanguage = () => {
  const apolloClient = useApolloClient();
  const { updateUserLanguage } = useUpdateUserLanguage();
  const { i18n } = useTranslation();

  const checkUpdateUserLanguage = () => {
    const selectedLanguage = i18n.language;

    const data: Nullable<MeQuery> = apolloClient.cache.read({
      query: MeDocument,
      optimistic: true,
    });

    if (
      !data?.me?.id ||
      !selectedLanguage ||
      !ABBREVIATIONS_BY_LANGUAGES_MAP[selectedLanguage] ||
      !LANGUAGES_BY_ABBREVIATIONS_MAP[data.me.language_abbr] ||
      LANGUAGES_BY_ABBREVIATIONS_MAP[data.me.language_abbr] === selectedLanguage
    ) {
      return;
    }

    updateUserLanguage({
      user_id: data.me.id,
      language_abbr: ABBREVIATIONS_BY_LANGUAGES_MAP[selectedLanguage],
    });
  };

  return checkUpdateUserLanguage;
};
